import { Tag } from "@/components/molecules/Tag";
import Image from "next/image";

export const ServiceItem = ({ href, src, title, lead, body, tags, solutions }) => {
  return (
    <>
      <div id={href} className="--offset col-span-1 space-y-2">
        <figure className="relative block aspect-3.7/1 w-full">
          <Image
            src={src}
            alt={title}
            quality={80}
            layout="fill"
            objectFit="cover"
          />
        </figure>
        <div className="space-y-2 px-6 py-2 sm:px-8 md:px-12 md:py-2 lg:py-3">
          <h4
            className="font-bold text-pri fluid-text-[16px,22px]"
            dangerouslySetInnerHTML={{
              __html: `${lead}`,
            }}
          />
          <div className="grid-cols-1 leading-comfort  text-txt-base fluid-text-[14px,18px]">
            <div
              dangerouslySetInnerHTML={{
                __html: `${body}`,
              }}
            />
          </div>
        </div>
        {solutions && solutions.length > 0 && (
          <div className="space-y-2 px-6 py-2 sm:px-8 md:px-12 md:py-2 lg:py-3">
            <h5 className="font-bold text-ter fluid-text-[12px,16px]">
              このような課題を解決します
            </h5>
            <ul className="space-y-1">
              {solutions.map((solution, index) => (
                <li key={index} className="flex items-start gap-2 leading-relaxed text-txt-base fluid-text-[14px,18px]">
                  <span className="text-ter mt-1">•</span>
                  <span>{solution}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        <h6 className="px-6 font-bold text-ter fluid-text-[12px,16px] sm:px-8 md:px-12 md:pb-2 md:pt-0 lg:pb-2 lg:pt-0">
          Keyword
        </h6>
        <div className="flex flex-row flex-wrap gap-2 bg-bgc-dark px-6 py-4 sm:px-8 md:px-12 md:py-3 lg:p-4">
          {tags.map(function (tag) {
            return <Tag key="{tag.index}">{tag.label}</Tag>;
          })}
        </div>
      </div>
    </>
  );
};
